import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/companies',
    name: 'company',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/company/index.vue')
  },
  {
    path: '/company/create',
    name: 'company-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/company/create.vue')
  },
  {
    path: '/companies/:id',
    name: 'company-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/company/edit.vue'),
    props: route => ({ editData: route.params.editData })
  }
]
